export const ROUTES = {
  CHANGE_PASSWORD: {
    path: "/Change-password",
    headerTitle: "",
  },
  HOME: {
    path: "/",
    headerTitle: "Dashboard",
  },
  // IN: {
  //   path: "/entrance-exam-enrollments",
  //   headerTitle: "Entrance Exam Enrollments ",
  // },
  DASHBOARD: {
    path: "dashboard",
    headerTitle: "",
  },
  CREATE_INTRODUCTION: {
    path: "introduction/create",
    headerTitle: "New Introduction",
  },
  INTRODUCTION_VIEW: {
    path: "introduction/view",
    headerTitle: "Pending Introduction",
  },
  INTRODUCTION_TRANSFER_REQUEST: {
    path: "introduction/request",
    headerTitle: "Introduction Request",
  },
  // VIEW_INTRODUCTION: {
  //   path: "introduction/view/submitted-form",
  //   headerTitle: "View Submitted Form",
  // },

  // without type working

  // INTRODUCTION_PENDING: {
  //   path: "introduction/view-remarks/forward/:introductionId",
  //   headerTitle: "Pending Introduction",
  // },
  INTRODUCTION_PENDING: {
    path: "introduction/view-remarks/:type/:id",
    headerTitle: "Pending Introduction",
  },
  FRIENDS_INTRODUCTION: {
    path: "friend",
    headerTitle: "New Friend Entry",
  },
  // INTRODUCTION_PENDING_TO_DISTRICT: {
  //   path: "introduction/pending-to-district",
  //   headerTitle: "Pending",
  // },
  NEW_FRIEND_SEARCH: {
    path: "friends/new-friend/search",
    headerTitle: "Search New Friend",
  },
  CREATE_NEW_FRIEND: {
    path: "new-friend/create",
    headerTitle: "New Friend Entry",
  },
  CHANGE_TO_FRIEND_SEARCH: {
    path: "new-friend/change/:id",
    headerTitle: "Change to New Friend",
  },
  FAMILY_DETAILS: {
    path: "family/details",
    headerTitle: "Family",
  },
  CREATE_NEW_FAMILY: {
    path: "members/family/create",
    headerTitle: "Create Family",
  },
  EDIT_FAMILY_MEMBER: {
    path: "family/edit",
    headerTitle: "Edit Family",
  },

  FRIEND_SEARCH: {
    path: "/friends/search",
    headerTitle: "Search Friends",
  },

  FRIEND_TRANSFER: {
    path: "friends/transfer",
    headerTitle: "Friend Transfer Request",
  },
  FRIEND_PENDING_TRANSFER: {
    path: "friend/transfer/pending",
    headerTitle: "Pending Transfer",
  },
  FRIEND_TRANSFER_REQUEST: {
    path: "friends/request",
    headerTitle: "Friend Transfer Request",
  },
  FRIEND_TRANSFER_FORM: {
    path: "friend/create-friend-transfer",
    headerTitle: "Transfer To",
  },

  FRIEND_DETAIL: {
    path: "/friend/details",
    headerTitle: "Friend Details",
  },
  FRIEND_EDIT_PROFILE: {
    path: "/friend/edit",
    headerTitle: "Edit Friend",
  },

  // FRIEND_REMARKS: {
  //   path: "/remarks/:type/:id",
  //   headerTitle: "Friend Transfer Request",
  // },
  MEMBER_TRANSFER: {
    path: "members/transfer",
    headerTitle: "Pending Transfer",
  },
  MEMBER_REQUEST: {
    path: "members/request",
    headerTitle: "Members Transfer Request",
  },
  ATTENDANCE: {
    path: "attendance",
    headerTitle: "Attendance",
  },
  ARCHIVE_ATTENDANCE: {
    path: "meetings/archive/view",
    headerTitle: "View Archive Attendance",
  },
  CREATE_PROFILE: {
    path: "/member/create/profile",
    headerTitle: "Create a profile",
  },
  MEMBER_SEARCH: {
    path: "/members/search",
    headerTitle: "Member Search",
  },
  MEMBER_EDIT_PROFILE: {
    path: "/members/edit",
    headerTitle: "Edit Member",
  },
  MARK_ATTENDANCE: {
    path: "meetings/mark",
    headerTitle: "Mark Attendance",
  },
  ARCHIVE_MARK_ATTENDANCE: {
    path: "meetings/archive",
    headerTitle: "Archive Attendance",
  },
  EMAILER_EDITOR: {
    path: "/emailer/editor",
    headerTitle: "Create Template",
  },
  EMAILER_TEMPLATES: {
    path: "/emailer/templates",
    headerTitle: "Select Template",
  },
  EMAILER_UPDATE: {
    path: "/emailer/update",
    headerTitle: "Update Template",
  },
  EMAILER: {
    path: "/emailer",
    headerTitle: "Select Recipients",
  },
  EMAILER_RECIPIENTS: {
    path: "/emailer/templates/add-recipients",
    headerTitle: "Select Recipients",
  },
  VIEW_RECIPIENTS: {
    path: "/emailer/templates/recipients",
    headerTitle: "View Recipients",
  },
  FILES_LIST: {
    path: "/contents",
    headerTitle: "BDS Contents",
  },
  HELP_PAGE: {
    path: "help",
    headerTitle: "Help",
  },
  EXAMINATIONS: {
    path: "examinations",
    headerTitle: "Examinations",
  },
  ORGANIZATION_STRUCTURE: {
    path: "organization-structure",
    headerTitle: "Organization Structure",
  },
  GOHONZON: {
    path: "gohonzon",
    headerTitle: "Gohonzon",
  },
  GOHOZON_SUBMISSION: {
    path: "gohonzon/submit",
    headerTitle: "APPLY GOHONZON",
  },
  GOHOZON_APPLY_PAGE: {
    path: "ghongon-aply",
    headerTitle: "Gohozon",
  },
  SUBMITTED_GHONZON_APPLICATION: {
    path: "application",
    headerTitle: "Submitted Gohonzon Applications",
  },
  GOHOZON_HANDOVER: {
    path: "gohon-handover",
    headerTitle: "Gohonzon Batch Handover",
  },
  GOHOZON_CONFERRAL: {
    path: "conferral",
    headerTitle: "Gohonzon conferral",
  },
  GOHOZON_CONFERRAL_STATUS: {
    path: "conferral-status",
    headerTitle: "Member Conferral Status",
  },
  GOHONZON_CANCELLATION_REQUEST: {
    path: "CANCELLATION",
    headerTitle: "Gohonzon Cancellation Request",
  },
  GOHONZON_APPROVAL_REQUEST: {
    path: "approval",
    headerTitle: "Submitted Omamori Gohonzon Applications",
  },
  GOHONZON_APPLICATIONS: {
    path: "/gohonzon/applications",
    headerTitle: "Gohonzon Applications",
  },
  APPLICATION_VERIFICATION: {
    path: "/gohonzon/application-verification",
    headerTitle: "Aplication Verification",
  },
  GOHONZON_INTERVIEW: {
    path: "gohonzon/interview",
    headerTitle: "Pending Application",
  },
  GOHONZON_VERIFICATION: {
    path: "gohonzon/verification",
    headerTitle: "Gohonzon Verification",
  },
  GOHONZON_BATCH_ALLOTMENT: {
    path: "gohonzon/batch-allotment",
    headerTitle: "Gohonzon Allotment",
  },
  GOHONZON_BATCH_HISTORY: {
    path: "gohonzon/batch-history",
    headerTitle: "Batch History",
  },
  GOHONZON_PENDING_INTERVIEW: {
    path: "gohonzon/submit/interview",
    headerTitle: "Pending Application",
  },
  APPLY_GOHONZON_RETURN: {
    path: "gohonzon/submit/return",
    headerTitle: "Return Gohonzon",
  },
  GOHONZON_BATCH_VIEW: {
    path: "gohonzon/history",
    headerTitle: "Gohonzon Applications",
  },
  PREVIEW_GOHONZON: {
    path: "/gohonzon/submit/allotment/preview",
    headerTitle: "View Gohonzon Application",
  },
  GOHONZON_ALLOTMENT: {
    path: "gohonzon/allotment",
    headerTitle: "Gohonzon Allotment",
  },
  GOHONZON_HANDOVER: {
    path: "gohonzon/handover",
    headerTitle: "Gohonzon Handover",
  },
  GOHONZON_BATCH_CONFERRAL: {
    path: "gohonzon/batch-conferral",
    headerTitle: "Gohonzon Conferral",
  },
  GOHONZON_CONFERRAL: {
    path: "gohonzon/conferral",
    headerTitle: "Gohonzon Conferral",
  },
  GOHONZON_CANCELLATION: {
    path: "gohonzon/cancel",
    headerTitle: "Gohonzon Cancellation Request",
  },
  GOHONZON_APPROVAL: {
    path: "gohonzon/approval",
    headerTitle: "Pending Application",
  },
  GOHONZON_RETURNED_HANDOVER: {
    path: "gohonzon/returned-handover",
    headerTitle: "Returned Gohonzon Handover",
  },
  ALLOTMENT_HISTORY: {
    path: "gohonzon/allotment-history",
    headerTitle: "Allotment History",
  },
  MEMBER_TRANSFER_REQUEST: {
    path: "/member/transfer-request",
    headerTitle: "Transfer To",
  },
  MEMBER_PENDING_TRANSFER: {
    path: "member/transfer/pending",
    headerTitle: "Pending Transfer",
  },
  REMARKS: {
    path: "remarks/:type/:id",
    headerTitle: "Remarks",
  },
  MEMBER_DETAIL: {
    path: "member/details",
    headerTitle: "Member Details",
  },
  MEMBER_DETAIL_FOR_MOBILE: {
    path: "member/details/mobile",
    headerTitle: "Member Details",
  },
  MEMBER_FAMILY_DETAIL: {
    path: "/family/details/:id",
    headerTitle: "Member / Family / Family Details",
  },
  NEW_MEMBER: {
    path: "members/create/:id",
    headerTitle: "Change to Member",
  },
  NEW_MEMBER_CREATE: {
    path: "members/create",
    headerTitle: "Create New Member",
  },
  MEMBER_DEACTIVATION: {
    path: "/members/deactivate",
    headerTitle: "Verify Member Deactivation",
  },
  MEMBER_REACTIVATION: {
    path: "/members/reactivate",
    headerTitle: "Member Reactivation",
  },
  FAMILY_DETAIL: {
    path: "members/family/detail",
    headerTitle: "Family Search",
  },
  VIEW_FAMILY_DETAIL: {
    path: "family/view",
    headerTitle: "Family Details",
  },
  APPLY_GOHONZON: {
    path: "/gohonzon/apply",
    headerTitle: "Apply Gohonzon",
  },
  GOHONZON_RETURN: {
    path: "gohonzon/return",
    headerTitle: "Gohonzon Return Request",
  },
  GOHONZON_RETURN_VERIFICATION: {
    path: "/gohonzon/return-verification",
    headerTitle: "Gohonzon Return Verification",
  },
  GOHONZON_REPLACEMENT_VERIFICATION: {
    path: "/gohonzon/replacement-verification",
    headerTitle: "Gohonzon Replacement Verification",
  },
  GOHONZON_OMAMORI_CONFERRAL: {
    path: "/gohonzon/omamori-conferral",
    headerTitle: "Gohonzon Omamori conferral",
  },
  GOHONZON_REPLACEMENT_CONFERRAL: {
    path: "/gohonzon/replacement-conferral",
    headerTitle: "Gohonzon Replacement conferral",
  },
  GOHONZON_OMAMORI_ALLOTMENT: {
    path: "gohonzon/omamori-allotment",
    headerTitle: "Gohonzon Omamori Allotment",
  },
  GOHONZON_OMAMORI_HANDOVER: {
    path: "gohonzon/omamori-handover",
    headerTitle: "Gohonzon Handover",
  },
  GOHONZON_INVENTORY: {
    path: "gohonzon/gohonzonInventory",
    headerTitle: "Gohonzon Inventory",
  },
  HANDOVER_INVENTORY: {
    path: "gohonzon/handoverInventory",
    headerTitle: "Handover Inventory",
  },
  MASTER_INVENTORY: {
    path: "gohonzon/masterInventory",
    headerTitle: "Master Inventory",
  },
  BLOCK_COMPONENT: {
    path: "block",
    headerTitle: "Show Block",
  },
  APPOINTMENT: {
    path: "appointment",
    headerTitle: "Appointment",
  },
  APPOINTMENT_SPLIT: {
    path: "appointment/split",
    headerTitle: "Split",
  },
  APPOINTMENT_SPLIT_FORM: {
    path: "appointment/split/form",
    headerTitle: "Split Form",
  },
  APPOINTMENT_SPLIT_NEW_STRUCTURE: {
    path: "appointment/split/form",
    headerTitle: "Split New Structure",
  },
  APPOINTMENT_SPLIT_EDIT: {
    path: "appointment/split/edit",
    headerTitle: "Split Edit Details",
  },
  NEW_STRUCTURE: {
    path: "new-structure",
    headerTitle: "Bulk Transfer",
  },
  NEW_STRUCTURE_BULK_TRANSFER: {
    path: "new-structure/bulk-transfer",
    headerTitle: "Bulk Transfer",
  },
  NEW_STRUCTURE_APPLY: {
    path: "new-structure/apply",
    headerTitle: "Search/ Add Structure",
  },
  NEW_STRUCTURE_APPLY_CREATE: {
    path: "new-structure/apply/create",
    headerTitle: "Bulk Transfer",
  },
  NEW_STRUCTURE_CHART: {
    path: "new-structure/organogram/chart",
    headerTitle: "View Organogram",
  },
  NEW_VIEW_ORGANOGRAM_CHART: {
    path: "new-view-structure/organogram/chart",
    headerTitle: "View Organogram",
  },
  NEW_STRUCTURE_VIEW_ORGANOGRAM: {
    path: "new-structure/organogram",
    headerTitle: "Organogram",
  },
  APPLY_APPOINTMENT: {
    path: "/appointment/apply",
    headerTitle: "Apply for Recommendation",
  },
  APPOINTMENT_REVIEW: {
    path: "/appointment/review",
    headerTitle: "Review for Recommendation",
  },
  APPOINTMENT_TRACKING: {
    path: "/appointment/tracking",
    headerTitle: "Appointment Applications Tracking",
  },
  APPOINTMENT_SUBMISSION_TRACKING: {
    path: "/appointment/submission/:type",
    headerTitle: "Appointment Tracking",
  },
  REVIEW_APPOINTMENT: {
    path: "/appointment/reviewcommittee",
    headerTitle: "Approval for Recommendation",
  },
  PARTIAL_REVIEW_APPOINTMENT: {
    path: "/appointment/partial-reviewcommittee",
    headerTitle: "Appointment Applications",
  },
  PARTIAL_APPROVED_APPOINTMENT: {
    path: "/appointment/partial-approveCommittee",
    headerTitle: "Appointment Applications",
  },
  APPOINTMENT_PROPOSE_APPLICATION: {
    path: "/appointment/mark",
    headerTitle: "Interaction for Appointment",
  },
  APPOINTMENT_SECOND_APPROVAL_APPLICATION: {
    path: "/appointment/second-approval",
    headerTitle: "Approval for Recommendation",
  },
  APPOINTMENT_PROPOSE_MARK_APPLICATION: {
    path: "/appointment/mark-appointment",
    headerTitle: "Mark for Appointment",
  },
  APPOINTMENT_SUBMISSION: {
    path: "/appointment/submission",
    headerTitle: "Appointment Proposal Form",
  },
  APPOINTMENT_FEEDBACK_MODAL: {
    path: "appointment/feedbacks",
    headerTitle: "Appointment Application Feedback",
  },
  APPOINTMENT_MARK_LOGIN_MODAL: {
    path: "appointment/feedbacks-markLogin",
    headerTitle: "Appointment Application Feedback",
  },
  SETTINGS: {
    path: "/settings",
    headerTitle: "Settings",
  },
  VIEW_ANNOUNCEMENT: {
    path: "/settings/announcement/view",
    headerTitle: "View Announcement",
  },
  APPOINTMENT_DIRECT: {
    path: "appointment/directAppointment",
    headerTitle: "Mainline Appointment - Entry",
  },
  APPOINTMENT_ADHOC: {
    path: "appointment/adhocAppointment",
    headerTitle: "Adhoc Appointment - Entry",
  },
  APPOINTMENT_FUTURE_DIVISION: {
    path: "appointment/futureDivisionAppointment",
    headerTitle: "Future Division Appointment - Entry",
  },
  APPOINTMENT_STUDENT: {
    path: "appointment/studentAppointment",
    headerTitle: "Student Division Appointment - Entry",
  },
  APPOINTMENT_UHG: {
    path: "appointment/uhgAppointment",
    headerTitle: "UHG Division Appointment - Entry",
  },
  NATIONAL_APPOINTMENT: {
    path: "appointment/nationalAppointment",
    headerTitle: "Mainline Appointment - Entry",
  },
  NATIONAL_SPECIAL_APPOINTMENT: {
    path: "appointment/national-special-Appointment",
    headerTitle: "National Special Group Appointment - Entry",
  },
  REPORTS_MEMBER: {
    path: "/reports/memebrs",
    headerTitle: "Member Report",
  },
  REPORTS_FRIEND: {
    path: "/reports/friends",
    headerTitle: "Friend Report",
  },
  REPORTS_DEACTIVATED_FRIEND: {
    path: "/reports/deactivated",
    headerTitle: "Deactivated Report",
  },
  REPORTS_CHANGED_TO_MEMBER: {
    path: "/reports/changetomember",
    headerTitle: "Change to Member Report",
  },
  REPORTS_FRIEND_SUMMARY: {
    path: "/reports/friendsummary",
    headerTitle: "Friend Summary Report",
  },
  REPORTS_FRIEND_CHANGED_TO_MEMBER_TRENDS: {
    path: "/reports/friendchangedtomembertrends",
    headerTitle: "Friend Changed To Member Trends Report",
  },
  REPORTS_FRIEND_TO_MEMBER_GROWTH: {
    path: "/reports/friendtomembergrowth",
    headerTitle: "Friend to Member Growth Report",
  },
  REPORTS_NEW_FRIEND_TRENDS: {
    path: "/reports/newfriendtrends",
    headerTitle: "New Friend Trends Report",
  },
  REPORTS_FRIEND_AGEING: {
    path: "/reports/friendsageing",
    headerTitle: "Friend Ageing Report",
  },
  REPORTS_ATTENDANCE: {
    path: "/reports/attendance",
    headerTitle: "Member Wise Attendance Report",
  },
  STRUCTURE_ATTENDANCE_REPORT: {
    path: "/reports/structure-attendance",
    headerTitle: "Structure Wise Attendance Report",
  },
  REPORTS_TRANSFER_LEADER_NOT_APPOINTED: {
    path: "/reports/appointment/transfer-leader-not-appointed",
    headerTitle: "Transfer Leader Not Appointed",
  },
  UNMARKED_ATTENDANCE_REPORT: {
    path: "/reports/unmarked-attendance",
    headerTitle: "Unmarked Attendance Report",
  },
  DOWNLOAD_REPORTS: {
    path: "/downloads/reports",
    headerTitle: "Download Report",
  },
  USER_MANAGEMENT: {
    path: "/user-management",
    headerTitle: "Search Member To Manage Role",
  },
  USER_MANAGEMENT_MEMBER_SEARCH: {
    path: "/settings/user-management/search",
    headerTitle: "Search Member To Manage Role",
  },
  QRSCANNER: {
    path: "/QRScanner",
    headerTitle: "Qr Scanner",
  },
  QRATTENDANCELOGIN: {
    path: "/qr-attendance-login",
    headerTitle: "Qr Attendance Login",
  },
  USER_IP_CONFIG_MANAGEMENT: {
    path: "/settings/user-management/ip-config",
    headerTitle: "Manage All IP's",
  },
  USER_PERMISSION_MANAGEMENT: {
    path: "/settings/user-management/permission",
    headerTitle: "Manage Permission",
  },
  UNIVERSITY_LIST: {
    path: "/university/list",
    headerTitle: "University List",
  },
  REPORTS_GOHONZON_CONFERRAL: {
    path: "/reports/gohonzon-conferral",
    headerTitle: "Gohonzon Conferral Report",
  },
  REPORTS_GOHONZON_ALLOTMENT: {
    path: "/reports/gohonzon-allotment",
    headerTitle: "Gohonzon Allotment Report",
  },
  SG_INDUCTION: {
    path: "/special-group/induction",
    headerTitle: "Division Special Group Induction",
  },
  SG_GRADUATION: {
    path: "/special-group/graduation",
    headerTitle: "Division Special Group Graduation",
  },
  SG_DIVISION: {
    path: "/division-graduation",
    headerTitle: "Division Graduation",
  },
  REPORTS_CURRENT_STATS: {
    path: "/reports/current-stats",
    headerTitle: "Monthly Statistics Report",
  },
  GOHONZON_CONSENT_URL: {
    path: "gohonzon/gohonzonConsentUrl",
    headerTitle: "Gohonzon Consent Url",
  },
  GOHONZON_TRACKING: {
    path: "/gohonzon/tracking",
    headerTitle: "Gohonzon Applications Tracking",
  },
  CONTROL_PANEL: {
    path: "/controlPanel",
    headerTitle: "Control Panel",
  },
  REPORTS_SUBSCRIPTION: {
    path: "/reports/subscription",
    headerTitle: "Subscription Report",
  },
  REPORTS_SUBSCRIPTION_TRENDS: {
    path: "/reports/subscriptiontrends",
    headerTitle: "Subscription Trends Report",
  },
  REPORTS_SUBSCRIPTION_MIS: {
    path: "/reports/subscriptionmis",
    headerTitle: "Subscription Mis Report",
  },
  REPORTS_EXPIRED_SUBSCRIPTION: {
    path: "/reports/expiredsubscription",
    headerTitle: "Expired Subscription Report",
  },
  REPORTS_NEAR_TO_EXPIRY_SUBSCRIPTION: {
    path: "/reports/neartoexpirysubscription",
    headerTitle: "Near To Expiry Subscription Report",
  },
  EXAMINATION_MEMBER_SEARCH: {
    path: "/examination/search",
    headerTitle: "Examination Member Search",
  },
  RESULT_MEMBER_SEARCH: {
    path: "/examination/resultMembers/search",
    headerTitle: "BSG Intermediate Examination 2025 Result",
  },
  APPLIED_MEMBER_SEARCH: {
    path: "/examination/appliedMembers/search",
    headerTitle: "Examination Applied Member Search",
  },
  TICKET_SYSTEM: {
    path: "/ticketSystem",
    headerTitle: "Ticket System",
  },
  TICKET_CREATE: {
    path: "/ticketSystem/cretae",
    headerTitle: "Create Ticket",
  },
  TICKET_LIST: {
    path: "/ticketSystem/list",
    headerTitle: "Ticket List",
  },
  IN: {
    path: "/intermediate-exam-enrollments",
    headerTitle: "Intermediate Exam Enrollments ",
  },
  FORCE_LOGOUT: {
    path: "/force-logout",
    headerTitle: "Force Logout",
  },
};
